export const defaultTooltipOptions = {
    placement: 'bottom-start',
    // placement: 'bottom-end',
    // placement: 'bottom-center',
    offset: [15, 15],
};
export function showTooltip(evt, target, options) {
    if (!target) {
        // console.log('showTooltip called without target');
        if (!(evt.target instanceof Element))
            return;
        const t = evt.target.closest('.btn-tooltip')?.querySelector('.tooltip');
        if (!t || !(t instanceof HTMLElement))
            return;
        target = t;
    }
    else if (typeof target === 'string') {
        const t = document.getElementById(target);
        if (!t)
            return;
        target = t;
    }
    if (!(target instanceof HTMLElement))
        return;
    const opts = { ...defaultTooltipOptions, ...options };
    if (!target.classList.contains('active')) {
        target.classList.add('active');
    }
    const width = target.offsetWidth;
    const height = target.offsetHeight;
    const placement = opts.placement || 'top-center';
    const p = placement.split('-');
    const vPlace = p[0];
    const hPlace = (p[1] || 'center');
    let left = 0;
    let top = 0;
    if (hPlace === 'start') {
        left = evt.clientX + opts.offset[0];
    }
    else if (hPlace === 'end') {
        left = evt.clientX - width + opts.offset[0];
    }
    else {
        left = evt.clientX - width / 2 + opts.offset[0];
    }
    if (vPlace === 'top') {
        top = evt.clientY - height - opts.offset[1];
    }
    else {
        top = evt.clientY + opts.offset[1];
    }
    if (left + width > window.innerWidth) {
        if (hPlace === 'start' || hPlace === 'center') {
            left = evt.clientX - width + opts.offset[0];
        }
        if (left + width > window.innerWidth) {
            const overflow = left + width - window.innerWidth;
            left -= overflow + 10;
        }
    }
    if (left < 0) {
        if (hPlace === 'end' || hPlace === 'center') {
            left = evt.clientX + opts.offset[0];
        }
    }
    if (top + height > window.innerHeight) {
        if (vPlace === 'bottom') {
            top = evt.clientY - height - opts.offset[1];
        }
        if (top + height > window.innerHeight) {
            const overflow = top + height - window.innerHeight;
            top -= overflow + 10;
        }
    }
    if (top < 0) {
        if (vPlace === 'top') {
            top = evt.clientY + opts.offset[1];
        }
    }
    if (target instanceof HTMLElement) {
        target.style.position = 'fixed';
        target.style.left = `${left}px`;
        target.style.top = `${top}px`;
    }
}
export function hideTooltip(evt, target) {
    if (!target) {
        // console.log('hideTooltip called without target', evt.target);
        if (!(evt.target instanceof Element))
            return;
        const t = evt.target.closest('.btn-tooltip')?.querySelector('.tooltip');
        if (!t || !(t instanceof HTMLElement))
            return;
        target = t;
    }
    else if (typeof target === 'string') {
        const t = document.getElementById(target);
        if (!t)
            return;
        target = t;
    }
    if (!(target instanceof HTMLElement))
        return;
    if (target.classList.contains('active')) {
        target.classList.remove('active');
    }
}
